<template>
  <t-switch
    v-model="hiddenOnMobile"
    data-testid="hide-section-on-mobile"
    :label="$t('forms.hide_on_mobile')"
    :disabled="disabled"
  ></t-switch>
</template>

<script lang="ts" setup>
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { TSwitch } from "@topol/twig-ui";
  import { computed } from "vue";

  defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const mjmlStore = useMjmlStore();

  const hiddenOnMobile = computed({
    get() {
      return mjmlStore.getActiveSectionAttrString("css-class") &&
        mjmlStore.getActiveSectionAttrString("css-class") ==
          "hide_section_on_mobile"
        ? true
        : false;
    },
    set() {
      unsetHidingOnAllChildren();

      const css = mjmlStore.getActiveSectionAttrString("css-class");
      mjmlStore.updateSectionAttribute({
        prop: "css-class",
        value:
          css && css == "hide_section_on_mobile"
            ? null
            : "hide_section_on_mobile",
      });
    },
  });

  function unsetHidingOnAllChildren() {
    //@ts-expect-error
    const sectionIndex = mjmlStore.selectedSection.sectionIndex as number;

    const selection = mjmlStore.getSelectedSectionByIndex();

    selection.children.forEach((col: any, colIndex: number) => {
      col.children.forEach((block: any, blockIndex: number) => {
        mjmlStore.updateSpecificBlockAttribute({
          prop: "css-class",
          value: "",
          sectionIndex: sectionIndex,
          columnIndex: colIndex,
          blockIndex: blockIndex,
        });
      });
    });
  }
</script>

<style></style>
